<!-- User Validation Modal -->
<div id="userValidationModal" class="modal fade in" role="dialog"
	style="display: block;  width:auto; height:auto; overflow-x: auto; overflow-y:auto; max-width: 100%; max-height: 100%; ">
	<div class="modal-dialog modal-md">
		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" data-dismiss="modal" (click)="hideDialog()"><i class="fa fa-times"
						aria-hidden="true"></i></button>
				<h4 class="modal-title">To Override Enter Username & Password for Validation</h4>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-sm-3" style="text-align:right">
						<label class=" input-label" for="shipmentNbr-input">User Name:</label>
					</div>
					<div class="col-xs-6">
						<input [(ngModel)]="mUserId" type="text" class="form-control input-lg" placeholder="User Name"
							required>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-3" style="text-align:right">
						<label class=" input-label" for="shipmentNbr-input">Password:</label>
					</div>
					<div class="col-xs-6">
						<input [(ngModel)]="mPassword" type="password" class="form-control input-lg"
							placeholder="Password" required>
					</div>
				</div>
				<div class="row" *ngIf="validationStatus !== null" style="margin-top: 15px;">
					<div class="col-sm-3" style="text-align:right">
						<label class="input-label">Status:</label>
					</div>

					<div class="col-xs-6">
						<span *ngIf="validationStatus" class="text-success">
							<i class="fa fa-check-circle"></i> Validation Successful
						</span>

						<span *ngIf="validationStatus === false" class="text-danger">
							<i class="fa fa-times-circle"></i> Validation Failed
						</span>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal" (click)="hideDialog()"><i class="fa fa-ban"
						aria-hidden="true"></i> CANCEL</button>
				<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="overrideClicked()"><i
						class="fa fa-arrow-right" aria-hidden="true"></i> OVERRIDE</button>
			</div>
		</div>
	</div>
</div>